type Props = {
  readonly content: string;
};

export const EmptyState = ({ content }: Props) => {
  return (
    <div className='flex max-w-7xl select-none items-center justify-center py-24'>
      <h2 className='text-balance text-center font-bold text-2xl text-gray-950 leading-tight sm:text-3xl'>
        {content}
      </h2>
    </div>
  );
};
